import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/openLibrary")({
  beforeLoad: () => {
    throw redirect({ to: "/kutuphane", statusCode: 301 });
  },
});
